module.exports = __webpack_public_path__ + "static/media/Banner-promo-M-Tigres-V4.3fd8fede.png";